<template>
  <div class="animated fadeIn">
    <b-row class="mb-3">
      <b-col md="3" class="pt-2">Grower</b-col>
      <b-col v-if="$store.getters.getAuthCustomerID">
        <b-input-group>
          <b-form-select
            v-model="form.customer_grower_id"
            :options="customer_grower_options"
          >
            <template slot="first">
              <option :value="null">
                Select Grower
              </option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group>
          <b-form-input
            type="text"
            v-model="form.grower"
            placeholder="Enter Project Grower"
            :state="!$v.form.grower.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="3" class="pt-2">Field</b-col>
      <b-col v-if="$store.getters.getAuthCustomerID">
        <b-input-group>
          <b-form-select
            v-model="form.customer_field_id"
            :options="customer_field_options"
            :disabled="!form.customer_grower_id"
          >
            <template slot="first">
              <option :value="null">
                Select Field
              </option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group>
          <b-form-input
            type="text"
            v-model="form.identifier"
            placeholder="Enter Project Field"
            :state="!$v.form.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Event Code" :label-cols="3">
          <b-form-input
            type="text"
            v-model="form.event_code"
            placeholder="Enter Project Event Code (optional)"
          ></b-form-input>
        </b-form-group>
      </b-col> </b-row
    ><b-row>
      <b-col>
        <b-form-group label="Irrigated?" :label-cols="3">
          <b-form-checkbox
            v-model="form.irrigated"
            value="1"
            unchecked-value="0"
          >
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CustomerGrowerCollection from '@/collections/crm/CustomerGrowerCollection'
import CustomerFieldCollection from '@/collections/crm/CustomerFieldCollection'

export default {
  name: "SoilFieldFormGroups",
  mixins: [validationMixin, ToastNotifications],
  props: ["submission", "index"],
  data() {
    return {
      form: {
        grower: null,
        identifier: null,
        event_code: null,
        irrigated: false,

        customer_grower_id: null,
        customer_field_id: null
      },

      customer_grower: new CustomerGrowerCollection(),
      customer_fields: new CustomerFieldCollection()
    }
  },
  validations: {
    form: {
      identifier: { required },
      grower: { required }
    }
  },
  computed: {
    customer_grower_options () {
      return this.customer_grower && this.customer_grower.models && this.customer_grower.models.map((grower) => {
        return {
          value: grower.id,
          text: grower.name
        }
      }) || []
    },
    customer_field_options () {
      return this.customer_fields && this.customer_fields.models && this.customer_fields.models.map((field) => {
        return {
          value: field.id,
          text: field.name
        }
      }) || []
    }
  },
  watch: {
    form: {
      handler() {
        this.$emit("onFieldChange", this.form);
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.form.grower = value.submission_soil.grower;
        this.form.identifier = value.identifier;
        this.form.event_code = value.event_code;
        this.form.irrigated = value.submission_soil.irrigated;
      },
      deep: true,
      immediate: true
    },
    'form.customer_grower_id': {
      handler (value) {
        if (value) {
          this.form.grower = this.customer_grower.models.find((grower) => grower.id === value).name
        } else {
          this.form.grower = null
        }

        this.form.customer_field_id = null
        this.fetchCustomerField()
      },
      immediate: true
    },
    'form.customer_field_id': {
      handler (value) {
        if (value) {
          this.form.identifier = this.customer_fields.models.find((field) => field.id === value).name
        } else {
          this.form.identifier = null
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.fetchCustomerGrower()
  },
  methods: {
    fetchCustomerGrower () {
      const collection = new CustomerGrowerCollection()
      const filter = collection.getFilter()

      filter.filterEquals('customer.id', this.$store.getters.getAuthCustomerID)

      collection.fetch().then(() => {
        this.customer_grower = collection
      })
    },

    fetchCustomerField () {
      const collection = new CustomerFieldCollection()
      const filter = collection.getFilter()

      filter.filterEquals('customer.id', this.$store.getters.getAuthCustomerID)
      filter.filterEquals('customer_grower_id', this.form.customer_grower_id)

      collection.fetch().then(() => {
        this.customer_fields = collection
      })
    }
  }
}
</script>
